import { render, staticRenderFns } from "./SubstantiveEvaluationList.vue?vue&type=template&id=c4c8a990&scoped=true&"
import script from "./SubstantiveEvaluationList.vue?vue&type=script&lang=js&"
export * from "./SubstantiveEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c8a990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
